/** @format */
import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'HomeProjectCell';

const classes = {
  editButton: `${PREFIX}-editButton`,
  editIcon: `${PREFIX}-editIcon`,
  titleBox: `${PREFIX}-titleBox`,
  title: `${PREFIX}-title`,
  rightColumn: `${PREFIX}-rightColumn`,
  popoverBox: `${PREFIX}-popoverBox`,
};

const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),

  [`& .${classes.title}`]: {
    color: theme.palette.figma_gray_light_1?.main,
    fontSize: 16,
    lineHeight: '20px',
    cursor: 'pointer',
  },

  [`& .${classes.editButton}`]: {
    width: '48px',
    height: '28px',
    borderRadius: '8px',
    transition: 'background 0.2s',
    '&:hover': {
      background: theme.palette.figma_gray_middle_dark?.main,
    },
    '&:active': {
      background: theme.palette.figma_gray_middle_light?.main,
      'svg path': {
        fill: theme.palette.figma_gray_middle_dark?.main,
      },
    },
  },
  [`& .${classes.editIcon}`]: {
    width: '16px',
    height: '16px',
    color: theme.palette.figma_gray_light_1?.main,
  },

  [`& .${classes.rightColumn}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexShrink: 0,
  },
  [`& .${classes.popoverBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    gap: theme.spacing(2),
  },
}));

export {classes as cellClasses, Root as CellRoot};
